module.exports = __webpack_public_path__ + "static/img/oneLogin_icon.1320bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/oneLogin_icon.png
// module id = vXrt
// module chunks = 1